import styled from 'styled-components';

export const StyledVideo = styled.video`
  width: 100%;
`;

StyledVideo.displayName = 'Pix Video';
